import type { StateCreator } from 'zustand';

export interface UploadSlice {
  pendingUploads: { id: string; file: File }[];
  addPendingUpload: (upload: { id: string; file: File }) => void;
  clearPendingUploads: () => void;
}

export const uploadInitialState = {
  pendingUploads: [] as { id: string; file: File }[],
};

export const createUploadSlice: StateCreator<
  UploadSlice,
  [],
  [],
  UploadSlice
> = (set) => ({
  ...uploadInitialState,

  addPendingUpload: (upload) =>
    set((state) => ({
      pendingUploads: [
        ...state.pendingUploads.filter((u) => u.id !== upload.id),
        upload,
      ],
    })),
  clearPendingUploads: () => set({ pendingUploads: [] }),
});
